export const ROUTES = {
    PROMOTION: '/promotion',
    DELIVERY: '/delivery',
    PAYMENT: '/payment',
    BONUSES: '/bonuses',
    ABOUT: '/about',
    CONTACTS: '/contacts',
    CAREERS: '/careers',
    SUPPLIERS: '/suppliers',
    PRIVACY_POLICY: '/privacy-policy',
    RETURNS: '/exchange-and-return-of-goods',
    CONSUMER_PROTECTION: '/consumer-protection',
    PUBLIC_OFFER: '/public-offer',
    HOME: '/',
    PROFILE: '/profile',
    CATEGORY: '/category/:categoryKey',
    SUBCATEGORY: '/subcategory/:subcategoryName',
    CART: '/cart',
    FAVORITES: '/favorites',
    COMPARISON: '/comparison',
    NOT_FOUND: '*',


}